import axios from "../../axios";
import { toast } from "react-toastify";
import { ADD_HSN_SUB, DELETE_HSN_SUB, GET_HSN_SUB, UPDATE_HSN_SUB } from "../types";

export const getHsnSub = (params) => async (dispatch) => {
    try {
      const res = await axios.get('/hsn/tax/all',{params});
  
      if (res.data.code === 1) {
        dispatch({ type: GET_HSN_SUB, payload: res.data.data });
      } 
    } catch (err) {
      if(err.response.data.errors[0].message){
        toast.error(err.response.data.errors[0].message);
      }
      // console.error("Failed to get HsnSub. Please try again. :", err);
    }
};

export const addHsnSub = (formData) => async (dispatch) => {
    try {
      const res = await axios.post('/hsn/tax/add', formData);
  
      if (res.data.code === 1) {
        dispatch({ type: ADD_HSN_SUB, payload: res.data.data });
        setTimeout(() => {
          toast.success("HsnSub added successfully!");
        }, 1000);
      } 
      if (res.data.code === 0) {
        setTimeout(() => {
          toast.error(res.data.message);
        }, 1000);
      } 
    } catch (err) {
      if(err.response.data.errors[0].message){
        toast.error(err.response.data.errors[0].message);
      }
    }
};

export const updateHsnSub = (formData) => async (dispatch) => {
    try {
      const res = await axios.post(`/hsn/tax/update`, formData);
  
      if (res.data.code === 1) {
        dispatch({ type: UPDATE_HSN_SUB, payload: res.data.data });
     
        setTimeout(() => {
          toast.success("HsnSub updated successfully!");
        }, 1000);
      } 
    } catch (err) {
      if(err.response.data.errors[0].message){
        toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to update HsnSub. Please try again.");
    }
};

// Delete HsnSub
export const deleteHsnSub = (id) => async (dispatch) => {
  try {
    if(!id){
      toast.error("Please select any record");
      return false;
    }
    const res = await axios.post(`/hsn/tax/delete/${id}`);
    if (res.data.code === 1) {
        dispatch({ type: DELETE_HSN_SUB, payload: {id} });
        setTimeout(() => {
          toast.success("Hsn Sub deleted successfully!");
        }, 1000);
      } 
  } catch (err) {
    if(err.response.data.errors[0].message){
      toast.error(err.response.data.errors[0].message);
    }
    // toast.error("Failed to delete HsnSub. Please try again.");
  }
};


